<div class="rounded-2xl bg-gray-200 px-4 py-2 flex items-center gap-2 w-full text-gray-900">
  <app-icon name="location" class="w-5 h-5 text-gray-600" />
  <span class="text-gray-600">Location:</span>
  <span class="font-semibold">{{ order().deliveryLocationName }}</span>
</div>
